const LESSON_MESSAGE_SOURCE = 'micropinouts-lesson';

export const emitLessonAnalyticsEvent = (eventName, payload = {}) => {
  const detail = {
    eventName,
    ...payload,
  };

  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function') {
    window.dispatchEvent(
      new CustomEvent('micropinouts:lesson-analytics', { detail })
    );
  }
};

export const postLessonMessage = (type, payload = {}) => {
  if (typeof window === 'undefined' || !window.parent || window.parent === window) {
    return;
  }

  window.parent.postMessage(
    {
      source: LESSON_MESSAGE_SOURCE,
      type,
      ...payload,
    },
    '*'
  );
};

export const createLessonMessage = (type, payload = {}) => ({
  source: LESSON_MESSAGE_SOURCE,
  type,
  ...payload,
});

export const isTrustedLessonMessage = (event, allowedOrigins = []) => {
  if (!event || !event.data || event.data.source !== LESSON_MESSAGE_SOURCE) {
    return false;
  }

  if (!Array.isArray(allowedOrigins) || allowedOrigins.length === 0) {
    return true;
  }

  return allowedOrigins.includes(event.origin);
};

